import {
  mobileLocalizationSchema,
  mobileLocalizationUiSchema,
} from '../../../../../components/JsonEditor/constants/LocalizationSchema/mobileLocalizationSchema';

import CustomizeLanguageLocalization from '../../../../../components/CustomizeLocalization/components/CustomizeLanguageLocalization';
import { CustomizeThemeLocalizationEntityLevel } from '../../../../../enums/CustomizeThemeLocalizationEntityLevel';
import { LocalizationComponentName } from '../../../../../enums/ComponentNameEnum';
import React from 'react';
import { useParams } from 'react-router-dom';

const CustomizeMobileLocalization: React.FC<{}> = () => {
  const { locationId } = useParams<{ locationId: string }>();

  return (
    <CustomizeLanguageLocalization
      title={'Customize mobile app & web localization'}
      componentName={LocalizationComponentName.MOBILE}
      schema={mobileLocalizationSchema}
      uiSchema={mobileLocalizationUiSchema}
      fileNameToDownloadDefaultJson={`Default mobile localization - Location ${locationId} - Language \${LANGUAGE_NAME}.json`}
      fileNameToDownloadCurrentJson={`Current mobile localization - Location ${locationId} - Language \${LANGUAGE_NAME}.json`}
      entityLevel={CustomizeThemeLocalizationEntityLevel.LOCATION}
      entityId={locationId}
    />
  );
};

export default CustomizeMobileLocalization;
